<template>

    <div class="imageList" >
        <ImageZoomable v-for="(image, index) in images"
                        v-bind="image"
                        :key="index">
        </ImageZoomable>
    </div>

</template>

<script>
    import ImageZoomable from "./ImageZoomable";
    export default {
        name: 'ImageList',
        components: {ImageZoomable},
        props: ['images'],
    };
</script>

<style scoped lang="scss">
    .imageList{
        display: flex;
        height: 50vh;
        margin-top: $G-default;
        @include breakpoint(xs){
            flex-wrap: wrap;
        }
        & > div{
            flex: 1 1 20%;

            @include breakpoint(xs){
                flex-basis: 50%;
                height: 25vh;
            }
        }
    }
</style>